import React, { useState } from "react";
import Chart from 'react-apexcharts'
import { ApexOptions } from "apexcharts"
import { getEpoch } from "_metronic/_helpers";
import { ModalInfo } from "../Globals";

export interface BaseMultipleYAxisDataProps {
  name: string
  type: "column" | "line"
  data: Array<number>
  color: string
}
export interface BaseMultipleYAxisProps {
  width?: number | string
  height?: number | string
  id: string
  title: string
  sortTitle?: string
  modalTitleId: string
  modalBodyTextId: string
  colors?: Array<string>
  labels?: Array<string>
  xAxis: Array<number> | Array<string>
  onDataSerie: () => Array<BaseMultipleYAxisDataProps> | null
  newDataSignal: number
}
function BaseMultipleYAxis(props: BaseMultipleYAxisProps) {
  const { width, height, id, title, sortTitle, modalTitleId, modalBodyTextId, xAxis, onDataSerie, newDataSignal } = props
  const [showSignal, setShowSignal] = useState<number>(0)

  const [options] = React.useState<ApexOptions>({
    chart: {
      id: id,
      toolbar: {
        show: true,
        tools: {
          selection: false,
          zoom: false,
          customIcons: [
            {
              index: 0,
              icon: "",
              class: "flaticon-questions-circular-button icon-lg ml-3",
              title: "Billy",
              click: () => setShowSignal(getEpoch())
            }
          ]
        }
      }      
    },
    title: {
      text: title,
      align: 'left',
      style: {

      }
    },
    plotOptions: {
      bar: {
        columnWidth: "50%"
      }
    },
    noData: {
      style: {
        color: "red"
      },
      text: "Nothing"
    },
    stroke: {
      curve: 'smooth',
      width: [3, 0, 0]
    },
    dataLabels: {
      enabled: true,
      textAnchor: "middle",
      offsetY: -5,
      style: {
        colors: ["black"]
      }
    },
    xaxis: {
      type: "category",
      categories: xAxis,
      crosshairs: {
        show: true
      }
    },
    yaxis: [
      {
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#008FFB'
        },
        labels: {
          style: {
            colors: '#008FFB',
          }
        },
        title: {
          text: "Monitoramentos",
          style: {
            color: '#008FFB',
          }
        },
        tooltip: {
          enabled: true
        }
      }
    ],
    // colors: colors,
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      labels: {

      }
    },
    responsive: [
      { 
        breakpoint: 1010,
        options: {
          title: {
            style: {
              fontSize: '12px'
            }
          }
        }
      },
      { 
        breakpoint: 275,
        options: {
          title: {
            style: {
              fontSize: '8px'
            }
          }
        }
      },
      { 
        breakpoint: 300,
        options: {
          title: {
            style: {
              fontSize: '10px'
            }
          }
        }
      },
      { 
        breakpoint: 435,
        options: {
          title: {
            text: sortTitle ? sortTitle : title
          }
        }
      },
      { 
        breakpoint: 9999,
        options: {
          title: {
            text: title
          },
          style: {
            fontSize: '12px'
          }
        }
      }
    ]
  })

  const [dataSerie, setDataSerie] = React.useState<Array<any>>([])
  React.useEffect(() => {
    const data = onDataSerie()
    if (!data) return

    setDataSerie(data)
    
  }, [newDataSignal, onDataSerie])

  return (
    <>
      <ModalInfo
        showSignal={showSignal}
        titleId={modalTitleId}
        bodyTextId={modalBodyTextId}
        />
      <Chart
        type="bar"
        options={options} 
        series={dataSerie} 
        width={width ?? '100%'} 
        height={height ?? '100%'} 
        />
    </>
  )
}
export default (BaseMultipleYAxis)
